import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CustomerSelectionModal from "./CustomerSelectionModal";
import PartSelectionModal from "./PartSelectionModal";
import PartService from "../../../Quotation/Controller/QuotationController";
import { handleChange, handleSubmit } from "../../Controller/CreateJobPartController";
import JobService from "../../Controller/JobController";
import Draggable from 'react-draggable';
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
const MODULE_IDS = {
    Assets: 3,
    Parts: 4,
    Suppliers: 5,
    Quotations: 6,
    SalesOrders: 7,
    Purchasing: 8,
    Agreements: 9,
    Jobs: 10,
    Contacts: 15,
};
function CreateJobPart({ jobPart, onClose, onSuccess, JobID }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        FK_Stock_ID: 0,
        FK_Issue_ID: JobID
    });
    const getCurrentDateTime = () => {
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // Format: YYYY-MM-DD
        const time = now.toTimeString().split(' ')[0]; // Format: HH:MM:SS
        return { date, time };
    };
    const { theme } = useContext(ThemeContext);
    const [partList, setPartData] = useState([]);
    const [selectedParts, setSelectedParts] = useState([]);
    const [showPartModal, setShowPartModal] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [assignedModules, setAssignedModules] = useState(new Set());
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    useEffect(() => {
        fetchJobDetail();
        fetchAssignedModules();
    }, []);

    const fetchParts = async (ClientCompanyID) => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await PartService.GetAllParts(redirectCallback, ClientCompanyID);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching parts:', error);
        }
    };
    const handlePartChange = (event, index, fieldName) => {
        const { value } = event.target;
        const updatedParts = [...selectedParts];
        const part = updatedParts[index];
        part[fieldName] = value;

        setSelectedParts(updatedParts);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        try {
            const redirectUserList = () => {
                navigate('/JobsList?saved=true');
            };
            formData.ID = 0;
            formData.FK_Issue_ID = JobID;

            const formDataWithParts = {
                formData: formData,
                selectedParts: selectedParts
            };
            debugger;
            const Message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);

            if (Message === "Data saved successfully") {
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                onSuccess();
                //    redirectUserList();
            }
            else {
                setShowSuccessMessage(true);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setTimeout(() => {
                    setShowSuccessMessage(false);
                }, 5000);
            }

        } catch (error) {
            console.error('Error submitting form:', error);
            setErrors({ submit: 'An error occurred while submitting the form. Please try again.' });
        }
    };
    const fetchJobDetail = async () => {
        try {
            if (JobID > 0) {
                const jobDetail = await JobService.GetJobByID(navigate, JobID);
                await fetchParts(jobDetail[0].ClientCompanyID);
            }
        }
        catch (error) {
            alert(error);
        }
    };

    const handlePartSelect = (part) => {
        const isDuplicate = selectedParts.some((selectedPart) => selectedPart.vc_StockCode === part.vc_StockCode);
        if (isDuplicate) {
            // Optionally, you can show a message to the user that the part is already added.
            alert("This part is already added to the list.");
            return;
        }
        const updatedPart = {
            ...part,
        };
        setSelectedParts((prevSelectedParts) => [...prevSelectedParts, updatedPart]);
    };

    const handleRemovePart = (index) => {
        const updatedParts = selectedParts.filter((part, i) => i !== index);
        setSelectedParts(updatedParts);
    };
    const handleAddRow = () => {
        const newRow = {
            vc_StockCode: "S1",            // Default Product Code
            vc_Description: "Free Text",            // Default Description (Free text)
            mon_SalesPrice: "0.00",        // Default Sale Price
            vc_UnitOfSale: "0.00",        // Default Quantity

            isNew: true  // This will help identify newly added rows
        };
        setSelectedParts([...selectedParts, newRow]);
    };

    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const CompanyID = localStorage.getItem("CompanyID");
    const fetchAssignedModules = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const modules = await ModuleService.GetCompanyModules(redirectCallback, "en", CompanyID);
            const moduleSet = new Set(modules.map(m => m.PK_SearchModule_ID)); // Store assigned module IDs in a Set
            setAssignedModules(moduleSet);
        } catch (error) {
            console.error('Error fetching assigned modules:', error);
        }
    };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade jobPartModal show d-block" id="jobPartModal" tabIndex="-1" aria-labelledby="jobPartModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-header" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p"
                               bounds={{ top: 0, bottom: window.innerHeight - 400 }}>
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{jobPart ? "Edit Part" : "Add Part"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ "maxHeight": "300px", "overflow": "auto" }}>
                                    {showSuccessMessage && (
                                        <div class="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                                            The part cannot be added because either it is not associated with a depot or it has insufficient quantity.

                                        </div>
                                    )}

                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "6px", "marginTop": "10px" }}>
                                        <table className="table m-0 table-hover">
                                            <thead>
                                                <tr>
                                                    <th data-sortable>Product Code</th>
                                                    <th data-sortable>Description</th>
                                                    <th data-sortable>Depot</th>
                                                    <th data-sortable>Free Stock</th>
                                                    <th data-sortable>Sale Price</th>
                                                    <th data-sortable>Quantity</th>
                                                    <th data-sortable>Free Stock</th>
                                                    <th style={{ "textAlign": "right" }}>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedParts.map((part, index) => (
                                                    <tr key={index}>
                                                        <td>

                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.vc_StockCode}
                                                                readOnly={!part.isNew}
                                                                onChange={(e) => handlePartChange(e, index, 'vc_StockCode')}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.vc_Description}
                                                                readOnly={!part.isNew}
                                                                onChange={(e) => {
                                                                    const updatedPart = { ...part, vc_Description: e.target.value };
                                                                    const updatedParts = [...selectedParts];
                                                                    updatedParts[index] = updatedPart;
                                                                    setSelectedParts(updatedParts);
                                                                }}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.DepotName}
                                                                readOnly={!part.isNew}

                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.DepotQuantity}
                                                                readOnly={!part.isNew}

                                                            />
                                                        </td>
                                                        <td>

                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.mon_SalesPrice}
                                                                readOnly={!part.isNew}
                                                                onChange={(e) => handlePartChange(e, index, 'mon_SalesPrice')}
                                                            />
                                                        </td>


                                                        <td>

                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.vc_UnitOfSale}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    // Regular expression to match a valid decimal number
                                                                    const decimalRegex = /^\d*\.?\d*$/;

                                                                    // Check if the value matches the decimal regex
                                                                    if (decimalRegex.test(value)) {
                                                                        const updatedPart = { ...part, vc_UnitOfSale: value };
                                                                        const updatedParts = [...selectedParts];
                                                                        updatedParts[index] = updatedPart;
                                                                        setSelectedParts(updatedParts);
                                                                    }
                                                                }}
                                                            />
                                                        </td>

                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={part.dec_FreeStock}
                                                                readOnly={!part.isNew}

                                                            />
                                                        </td>
                                                        <td style={{ "textAlign": "right" }}>
                                                            <button
                                                                type="button"
                                                                style={{ "background": "none", "border": "none" }} className="text-danger"
                                                                onClick={() => handleRemovePart(index)}
                                                            >
                                                                <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                        {errors.selectedParts && <div style={{ color: 'red' }}>{errors.selectedParts}</div>}
                                    </div>
                                    {/* Add more form fields as needed */}
                                    <div className="row mb-3" style={{ "marginLeft": "10px", "marginRight": "0px" }}>
                                        <div className="col-sm-6">

                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer part-footer">
                                    <button type="button" className="btn btn-primary" onClick={() => setShowPartModal(true)} disabled={!assignedModules.has(MODULE_IDS.Parts)}>
                                        <i className="icofont-plus" aria-hidden="true">Add Part</i>
                                    </button>
                                    <button type="button" className="btn btn-secondary" onClick={handleAddRow}>
                                        <i className="icofont-plus" aria-hidden="true">Add Text</i>
                                    </button>

                                    <button className="btn btn-danger" style={{ "textAlign": "right", "float": "right" }} type="button" aria-label="Close" onClick={onClose}>
                                       <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                    <button type="submit" style={{ "textAlign": "right", "float": "right" }} className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  {jobPart ? " Update" : " Save"}
                                    </button>

                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>


            </form>
            <PartSelectionModal
                show={showPartModal}
                onClose={() => setShowPartModal(false)}
                parts={partList}
                onSelectPart={handlePartSelect}
            />


        </div>


    );
}
export default CreateJobPart;

